module.exports = __webpack_public_path__ + "static/media/sam-logo.50eb32a8.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/sam-logo.png
// module id = 177
// module chunks = 0